'use client';

import { useTranslations } from 'next-intl';
import Button from '@/components/ui/Button';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const t = useTranslations('error');

  // Suppress browser extension errors silently (e.g., MetaMask, crypto wallets)
  const isExtensionError = error.stack?.includes('chrome-extension://') || error.message?.includes('MetaMask') || error.message?.includes('Failed to connect');

  if (isExtensionError) {
    return null;
  }

  return (
    <section className="flex min-h-screen flex-col items-center justify-center px-margin-mobile text-center lg:px-margin-desktop">
      <h1 className="font-headline text-headline-lg font-bold tracking-[0.02em] text-on-surface">
        {t('title')}
      </h1>
      <p className="mt-stack-md max-w-md text-body-md text-on-surface-variant md:text-body-lg">
        {t('desc')}
      </p>
      <Button variant="primary" size="lg" className="mt-stack-lg" onClick={reset}>
        {t('retry')}
      </Button>
    </section>
  );
}
